<mat-card>
    <mat-card-title>
        Novo Cadastro
    </mat-card-title>

    <form >
        <mat-form-field class="input">
            <input matInput placeholder="Nome do animal" [(ngModel)]="nome" name="nome">
        </mat-form-field>

        <mat-radio-group
        aria-labelledby="example-radio-group-label"
        class="example-radio-group"
        [(ngModel)]="grupoAnimal"
        name="grupoAnimal">
            Especie:
            <mat-radio-button class="radio-button" value="Cachorro"> Cachorro </mat-radio-button>
            <mat-radio-button  class="radio-button" value="Gato"> Gato </mat-radio-button>
          </mat-radio-group>

        <mat-form-field>
            <input matInput placeholder="Local - exemplo: RJ, Ilha do Governador"  [(ngModel)]="local" name="local">
        </mat-form-field>    
    </form>

    <button mat-raised-button (click)="criarAnimal()" color="primary">
        Salvar
    </button>

    <button mat-raised-button (click)="cancel()">
        Cancelar
    </button>
</mat-card>